/* eslint-disable max-statements */
import { getDevice } from '@catalogo/shell-web/src/server/helpers/device';
import { cookies } from '@catalogo/core-cookies';
import md5 from 'browser-md5';

export const criteoInit = config => {
  document.addEventListener('page:load', ({ detail }) => {
    try {
      const { page, search, user, product, project } = detail;
      const { type } = page;
      const { 'B2W-PID': b2wPid = '' } = cookies.getAll();

      if ((project?.brand === 'acom' && type === 'search') || !['home', 'search', 'product'].includes(type)) {
        return null;
      }

      const criteo = document.createElement('script');
      criteo.type = 'text/javascript';
      criteo.async = true;
      criteo.src = '//static.criteo.net/js/ld/ld.js';
      document.getElementsByTagName('body')[0].appendChild(criteo);

      const customerId = user['customer.id'];
      const device = getDevice() === 'mobile' ? 'm' : 'd';
      const pageField = getPageField(page?.type, search, product);

      window.criteo_q = window.criteo_q || [];
      window.criteo_q.push(
        {
          event: 'setAccount',
          account: config.criteo.id,
        },
        {
          event: 'setCustomerId',
          id: customerId ? md5(customerId) : '',
        },
        {
          event: 'setSiteType',
          type: device,
        },
        {
          event: 'setRetailerVisitorId',
          id: b2wPid,
        },
        pageField
      );
    } catch (e) {
      console.error(e);
    }
  });
};

const getPageField = (pagetype, search, product) => {
  switch (pagetype) {
    case 'home':
      return { event: 'viewHome' };
    case 'search':
      return {
        event: 'viewList',
        item: `[${search?.products?.slice(0, 3)}]`, // send only 3 ids to make request faster
        tagplace: window.location.href,
      };
    case 'product':
      return {
        event: 'viewItem',
        item: product?.id,
        isSponsored: window.location.href.indexOf('pfm_type=vit_recommendation') > -1 ? 1 : 0,
        tagplace: window.location.href,
      };
  }
};
